import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { WorkshopHero } from '../components/workshop/WorkshopHero';
import { WorkshopProblem } from '../components/workshop/WorkshopProblem';
import { WorkshopCurriculum } from '../components/workshop/WorkshopCurriculum';
import { WorkshopBenefits } from '../components/workshop/WorkshopBenefits';
import { WorkshopAbout } from '../components/workshop/WorkshopAbout';
import { WorkshopForWho } from '../components/workshop/WorkshopForWho';
import { WorkshopTestimonials } from '../components/workshop/WorkshopTestimonials';
import { WorkshopFinalCTA } from '../components/workshop/WorkshopFinalCTA';
export function WorkshopPage() {
  return <div className="min-h-screen bg-brand-cream font-body text-brand-text selection:bg-brand-gold selection:text-white overflow-x-hidden" data-id="element-2430">
      <Header data-id="element-2431" />
      <main data-id="element-2432">
        <WorkshopHero data-id="element-2433" />
        <WorkshopProblem data-id="element-2434" />
        <WorkshopCurriculum data-id="element-2435" />
        <WorkshopBenefits data-id="element-2436" />
        <WorkshopAbout data-id="element-2437" />
        <WorkshopForWho data-id="element-2438" />
        <WorkshopTestimonials data-id="element-2439" />
        <WorkshopFinalCTA data-id="element-2440" />
      </main>
      <Footer data-id="element-2441" />
    </div>;
}